/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useGetCCMClusters } from '@modules/ccm-user-lib/hooks'
import usePermissions from '@modules/permissions-lib/hooks'
import { isCCMFeatureActivated } from '@modules/ccm-user-lib/feature'

import type { UseQueryOptions } from 'react-query'
import type { ResourceQueryResult } from '../types'

export const useResourcesQuery = (
  options?: Pick<UseQueryOptions, 'enabled'>,
): ResourceQueryResult => {
  const enabled = options?.enabled ?? true

  const isCCMEnabled = isCCMFeatureActivated()

  const hasListCCMPermission = usePermissions(
    [{ type: 'cloud-connected-resource', action: 'list' }],
    'every',
    {
      enabled: isCCMEnabled && enabled,
    },
  ).hasPermissions

  const ccmClusterQuery = useGetCCMClusters({
    enabled: hasListCCMPermission,
  })

  return {
    resourceType: 'cloud-connected',
    data: ccmClusterQuery.data?.items,
    isLoading: ccmClusterQuery.isLoading,
    error: ccmClusterQuery.error,
    isEnabled: hasListCCMPermission,
  }
}
